
      // Wait for MSW to be ready before loading external scripts in development
      if (import.meta.env.DEV) {
        // Wait for MSW initialization
        document.addEventListener('DOMContentLoaded', async () => {
          // Wait for MSW ready signal from main.tsx
          while (!window.__MSW_READY__) {
            await new Promise((resolve) => setTimeout(resolve, 50))
          }
          await window.__MSW_READY__
          console.log('[MSW] External scripts loading after MSW ready')
          loadExternalScripts()
        })
      } else {
        // In production, load immediately
        document.addEventListener('DOMContentLoaded', loadExternalScripts)
      }

      function loadExternalScripts() {
        // Load NAV decorator
        const decoratorScript = document.createElement('script')
        decoratorScript.type = 'text/javascript'
        decoratorScript.src = 'https://www.nav.no/dekoratoren/client.js'
        document.head.appendChild(decoratorScript)

        // Load representasjon banner
        const bannerScript = document.createElement('script')
        bannerScript.type = 'module'
        bannerScript.src = 'https://www.nav.no/pensjon/selvbetjening/representasjon/banner.js'
        document.head.appendChild(bannerScript)
      }
    